// extracted by mini-css-extract-plugin
module.exports = {"labelContainer":"FieldLabel_labelContainer__w_oT0","icon":"FieldLabel_icon__Kzfvb"};